module.exports = __webpack_public_path__ + "static/media/advantage03.3a6d9bba.png";